import { toggleTabs } from "../../Tabs/toggleTabs";

export const reportList = () => {
  const formId = "report-list-form";
  const resultWrapperId = "report-list-result";

  let currentTab: string | null = null;

  /** Wires up event to post form whenever the year filter is updated */
  const wireUpYearFilter = () => {
    const form = document.getElementById(formId) as HTMLFormElement;

    const yearSelect = form.querySelector<HTMLSelectElement>("#year-filter");

    if (yearSelect) {
      yearSelect.addEventListener("change", () => {
        refreshForm(yearSelect.closest("form") as HTMLFormElement);
      });
    }
  };

  /** Posts a form asynchronously and returns the response HTML. */
  const postForm = (form: HTMLFormElement) => {
    const formData = new FormData(form);
    
    if (currentTab?.length) {
      formData.append("type", currentTab);
    }

    const selectedYear = document
      .getElementById(formId)
      ?.querySelector<HTMLSelectElement>("#year-filter")
      ?.value;

    if (selectedYear?.length) {
      formData.append("year", selectedYear);
    }
    
    return new Promise<string>((resolve, reject) => {
      fetch(form.action, {
        method: "POST",
        body: formData,
      })
        .then(response => response.text())
        .then(html => {
          resolve(html);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  /** Posts the current form and expects HTML to be returned for updating the page. */
  const refreshForm = (form: HTMLFormElement) => {
    postForm(form).then(
      html => {
        const container = document.getElementById(resultWrapperId) as HTMLElement;

        container.outerHTML = html;

        updateUrl();

        initialize(false);
      },
      error => {
        console.error("Failed to refresh Product Finder", error);
      }
    );
  };

  const configureForm = () => {
    // Prevent POST of form, as we'll do it async (AJAX)
    const form = document.getElementById(formId) as HTMLFormElement;

    form.onsubmit = event => {
      event.preventDefault();
    };

    // Prevent form from being submitted by hitting Enter
    form.addEventListener("keydown", event => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    });
  };

  const updateUrl = () => {
    const params = new URLSearchParams(window.location.search);

    const selectedYear = document
      .getElementById(formId)
      ?.querySelector<HTMLSelectElement>("#year-filter")
      ?.value;

    let hasParameters = false;
    
    if (selectedYear) {
      params.set("year", selectedYear);
      hasParameters = true;
    }
    else {
      params.delete("year");
    }

    if (currentTab?.length) {
      params.set("type", currentTab);
      hasParameters = true;
    }

    const queryString = hasParameters ? `?${params.toString()}` : "";

    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${queryString}`;

    window.history.replaceState({}, "", newUrl);
  }

  const onTabToggled = (tabId: string) => {
    currentTab = tabId;
    updateUrl();
  };

  const initialize = (firstInitialization: boolean) => {
    if (firstInitialization) {
      // Actual filter form is not rebuild and therefore does not need reinitialization.
      wireUpYearFilter();

      configureForm();
    }

    toggleTabs(onTabToggled);
  };

  initialize(true);
};
